mutation DeleteConfigs($ids: [ID!]!) {
  deleteConfigs(ids: $ids) {
    id
    deletedAt
  }
}
